import React, { useState, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addStatutoryIndustryAction,
    updateStatutoryIndustryAction,
    deleteStatutoryIndustryAction,
    addQualificationsAction,
    updateQualificationsAction,
    deleteQualificationsAction
} from '../../../redux/actions/admin/adminAction';
import Select from "react-select";
import { groupdata } from '../helper/index'

export const Qualification = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'education': '', 'education_grade': '', 'score': '' })
    const [show, setShow] = useState(false);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            top: "5px",
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "#309CCA" : "#309CCA",
        }),
    };

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'education': '', 'education_grade': '', 'score': '' })
        setShow(false)
    };

    const handleSeclect = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            ['education_grade']: event.id
        }))
    }


    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateQualification(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addQualification(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteQualification(id)
    }

    const groupEducationdata = (table1, table2, key, label, label2) => {
        table1.forEach(row1 => {
            table2.forEach(row2 => {
                if (row1.id === row2[key]) {
                    // console.log(row1.id + " " + row1.sector + " " + row2.sector);
                    row2[label] = row1[label2]
                }
            }
            )
        });
        return table2
    }

    const [qualificationColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Education", field: 'education', filter: true, },
        { headerName: "Education Grade", field: 'education_name', filter: true, },
        { headerName: "Score", field: 'score', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])
    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={groupEducationdata(props.educations, props.qualifications, 'education_grade', 'education_name', 'education')}
                defaultColDef={defaultColDef}
                columnDefs={qualificationColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Qualification</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <h3>Qualification</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="education"
                                name="education"
                                value={inputData.education}
                                onChange={handleChange}
                                placeholder="Qualification"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Education Grade</h3>
                        <div className="">
                            <Select
                                id="education_grade"
                                name="education_grade"
                                options={props.educations}
                                value={inputData.education ?
                                    props.educations.find(
                                        (row) =>
                                            row.id === inputData.education_grade) :
                                    null
                                }
                                getOptionLabel={(option) => option.education}
                                getOptionValue={(option) => option.id}
                                onChange={(event) => handleSeclect(event)}
                                placeholder="Choose.."
                                isClearable={true}
                                styles={customStyles}

                            />
                        </div>
                        <br></br>
                        <h3>Score</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="score"
                                name="score"
                                value={inputData.score}
                                onChange={handleChange}
                                placeholder="Score"
                                autoComplete="off"
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const educations = state.admin.educations;
    const qualifications = state.admin.qualifications;

    return {
        educations: educations,
        qualifications: qualifications,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addQualification: (data) => dispatch(addQualificationsAction(data)),
        updateQualification: (id, data) => dispatch(updateQualificationsAction(id, data)),
        deleteQualification: (id) => dispatch(deleteQualificationsAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(Qualification)
